import Head from 'next/head';
import React from 'react';
import { ArticlesList } from '../components';
import { withLayout } from '../Layout/Layout';

function TopLists() {
  return (
    <>
      <Head>
        <link rel="canonical" href={`${process.env.apiUrl}/cars`} />
      </Head>
      <ArticlesList type="Cars" heading="Cars" />
    </>
  );
}

export default withLayout(TopLists, false);
